



















































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import ListInputDialog from "@/components/forms/ListInputDialog.vue";
import { getModule } from "vuex-module-decorators";
import Modelling from "@/store/modules/Modelling";
import Decisions from "@/store/modules/Decisions";
import { FactorResource } from "@/api/model/FactorResource";

const decisionsModule = getModule(Decisions)

@Component({
    components: {ListInputDialog}
})

export default class AddResourceButton extends Vue {

    @Prop()
    btnClass!: string;

    @Prop()
    text!: string;

    @Prop({default: false, type: Boolean})
    small: boolean;

    @Prop({default: false, type: Boolean})
    xSmall: boolean;

    @Prop({default: false, type: Boolean})
    isParentFactor!: boolean;

    @Prop()
    loading!: boolean;

    @Prop({default: "mdi-plus-outline", type: String})
    vicon!: string;

    @Prop()
    color!: string;


    private confirmationDialog = false;
    private menuOpen = false;

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel
    }

    private addClick() {
        if (this.isParentFactor) {
            this.confirmationDialog = true;
        } else {
            this.create();
        }
    }

    @Emit()
    private create() {
        return '';
    }

     private submit(list: any) {
            if (list) {
                this.$emit('submit', list);
            }
        }

}
